var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "info-view", attrs: { id: "info-view" } }, [
    _c("div", { staticClass: "container-fluid my-3" }, [
      _c("div", { staticClass: "row px-1 d-block d-lg-flex" }, [
        _c(
          "div",
          { staticClass: "col-11 col-lg-6 image-div" },
          [
            _c("responsive-picture-ob1", {
              attrs: { dto: _vm.dto.image, "css-classes": null },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-div col-11 col-lg-7 pt-3 pb-1 px-1 p-lg-3 bg-gray2",
          },
          [
            _c("h1", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.dto.pageTitle)),
            ]),
            _vm._v(" "),
            _vm.dto.boldText
              ? _c("p", { staticClass: "d-flex align-items-center" }, [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(_vm.dto.boldText) },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.text
              ? _c("p", {
                  staticClass: "mb-2",
                  domProps: { innerHTML: _vm._s(_vm.dto.text) },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isWebView || _vm.dto.showButtonInWebview
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary me-1 mb-1 mb-xl-0",
                    attrs: {
                      href: _vm.dto.buttonLink,
                      "data-oevent-category": _vm.dto.buttonTms.category,
                      "data-oevent-action": _vm.dto.buttonTms.action,
                      "data-oevent-label": _vm.dto.buttonTms.label,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.dto.buttonLabel) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }